import React, { useState, useEffect } from 'react';
import useFetch from '../../hooks/useFetch';
import { LoadingIcon } from '@prosolve/common-components-ui'
import useIsMobileView from "../../hooks/useIsMobileView";
import EventLeftHud from './EventLeftHud/EventLeftHud';
import EventMainContent from './EventMainContent/EventMainContent';

export default ({
  isPublicView
}) => {
  const isMobileView = useIsMobileView();

  const urlParams = new URLSearchParams(window.location.search);
  const eventId = urlParams.get('id');
  const showFeedback = (urlParams.get('showFeedback') === 'true')

  const [isLoading, setIsLoading] = useState(true)
  const [eventData, setEventData] = useState({});

  const fetch = useFetch();

  const fetchEventData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`events/event?id=${eventId}`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setEventData({})
      } else {
        setEventData(jsonData)
      }
    } catch (e) {
      setEventData({})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (eventId) {
      fetchEventData()
    } else {
      // Below is used for when url may be hit without an id provided in the url
      setIsLoading(false)
      setEventData({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  return (
    <div style={{
      display: 'flex',
      padding: isMobileView ? '5px' : '5px 20px', 
      columnGap: '20px'
    }}>
      {
        isLoading ?
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '650px'
        }}>
          <div style={{ marginTop: '40px' }}>
            <LoadingIcon />
          </div>
        </div>
        :
        <>
        {
          !isMobileView &&
          <EventLeftHud eventData={eventData} />
        }
        <EventMainContent 
          eventData={eventData} 
          onReloadData={() => fetchEventData()} 
          isPublicView={isPublicView} 
          showFeedback={showFeedback}
        />
        </>
      }
    </div>
  )
}